import { store } from '../state/AppStore'
import { updateUser, updateUserStatistics, updateWallet } from '../state/reducers/activeUser'
import { setOtherProfiles, setDepositBonus, addLobbyChatMessage, updateLobbyStats, updateLobbyChat } from '../state/reducers/ProfileDataReducer'
import { setAdminMessage, setUsersOnline } from '../state/reducers/AppConfig'
import { setLoadingRooms, updateRooms } from '../state/reducers/RoomsReducer'
import { websocketConnection } from './websockets/Websockets'

class UpdateService
{
    setup()
    {
		websocketConnection.listenStatsUsersOnline((count) => {
			store.dispatch(setUsersOnline(count.usersCount))
        })
		websocketConnection.listenAdminMessage((message) => {
			store.dispatch(setAdminMessage(message))
        })
		websocketConnection.listenToUserStats((update) => {
			const { user } = store.getState().activeUser
			if (user && update.userId === user.id) {
				store.dispatch(updateUserStatistics(update.statistics))
			}
		})
		websocketConnection.listenToLobby((chat) => {
			store.dispatch(addLobbyChatMessage(chat))
		}, (stats) => {
			store.dispatch(updateLobbyStats(stats))
		})
    }
	
	cleanup()
	{
		websocketConnection.stopListenToUserStats()
		websocketConnection.stopListenAdminMessage()
		websocketConnection.stopListenToLobby()
	}
	
	refreshAll()
	{
		this.refreshRankings()
		this.refreshUser()
		this.refreshWallet()
		this.refreshOtherProfiles()
		this.refreshRooms()
		this.refreshDepositBonus()

		this.refreshLobbyChatHistory()
	}

	refreshRooms()
	{
		store.dispatch(setLoadingRooms(true))

		websocketConnection.requestRoomsUpdate((rooms) => {
			store.dispatch(updateRooms(rooms))
		})
	}

	refreshWallet()
	{
		websocketConnection.requestWalletUpdate((wallet) => {
			store.dispatch(updateWallet(wallet))
		})
	}

	refreshOtherProfiles(callback?: () => void)
	{
		websocketConnection.requestOtherProfilesUpdate((profiles) => {
			store.dispatch(setOtherProfiles(profiles))
			if (callback){
				callback()
			}
		})
	}

	refreshDepositBonus()
	{
		websocketConnection.requestDepositBonusUpdate((bonus) => {
			store.dispatch(setDepositBonus(bonus))
		})
	}

	refreshUser(callback?: () => void)
	{
		websocketConnection.requestUserUpdate((user) => {
			store.dispatch(updateUser(user))
			if (callback){
				callback()
			}
		})
	}

	refreshRankings()
	{
		// websocketConnection.requestRankings((rankings) => {
		// 	/* TODO */
		// })
	}

	refreshLobbyChatHistory(callback?: () => void)
	{
		websocketConnection.requestLobbyChatHistory((messages) => {
			store.dispatch(updateLobbyChat(messages))
			if (callback){
				callback()
			}
		})
	}
}

export const updateService = new UpdateService()
